import styled from 'styled-components'

export const TabPillsContainer = styled.div`
  margin-bottom: var(--space-500);
`
